import { detailsBig, h2, paragraph } from "@/styles/typography";
import styled from "styled-components";

const Container = styled.div<{ backgroundColor: string }>`
  display: flex;
  flex-direction: column;
  padding: 100px 70px;
  background-color: ${(props) => props.backgroundColor};

  min-height: 400px;
  margin-bottom: ${({ theme }) => theme.margins.bottom};
  width: calc(100% + 140px);
  margin-left: -70px;

  @media ${({ theme }) => theme.breakpoints.md} {
    width: 100vw;
    margin-left: -70px;
    padding: 50px;
  }

  @media ${({ theme }) => theme.breakpoints.sm} {
    margin-left: -20px;
    padding: 50px 16px;
    margin-bottom: ${({ theme }) => theme.margins.bottomMobile};
  }
`;

const SubTitle = styled(detailsBig)<{ backgroundColor: string }>`
  color: ${(props) => (props.backgroundColor === "white" ? "#000" : "#fff")};
  margin-bottom: 70px;
`;

const TitleWrapper = styled.div`
  max-width: 522px;
  @media ${({ theme }) => theme.breakpoints.sm} {
  }
`;

const Title = styled(h2)<{ backgroundColor: string }>`
  margin: 50px 0 20px 0;
  color: ${(props) => (props.backgroundColor === "white" ? "#000" : "#fff")};
  text-transform: uppercase;

  @media ${({ theme }) => theme.breakpoints.sm} {
    margin: 50px 0 0 0;
  }
`;

const AccentTitle = styled.span`
  color: #a78f67;
`;

const Paragraph = styled(paragraph)<{ backgroundColor: string }>`
  color: ${(props) => (props.backgroundColor === "white" ? "#000" : "#fff")};
`;

const TextWrapper = styled.div`
  display: flex;
  flex-direction: column;
  padding: 50px;
  justify-content: space-between;
`;

const ColumnWrapper = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  gap: 70px;

  @media ${({ theme }) => theme.breakpoints.sm} {
    grid-template-columns: 1fr;
    gap: 0px;
  }
`;

const Column = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: top;

  @media ${({ theme }) => theme.breakpoints.sm} {
    justify-content: center;
  }
`;

const S = {
  Container,
  TitleWrapper,
  SubTitle,
  Title,
  AccentTitle,
  Paragraph,
  TextWrapper,
  ColumnWrapper,
  Column,
};

export default S;
